// extracted by mini-css-extract-plugin
module.exports = {"mobileCountdownHolder":"MobileEventCountdown_mobileCountdownHolder__2mYM_","itemHolder":"MobileEventCountdown_itemHolder__3UAIw"};